module.exports = __webpack_public_path__ + "static/result-fail.5857abe9.png";